import { render, staticRenderFns } from "./OrganisationInvites.vue?vue&type=template&id=37ad74e9&scoped=true"
import script from "./OrganisationInvites.vue?vue&type=script&lang=js"
export * from "./OrganisationInvites.vue?vue&type=script&lang=js"
import style0 from "./OrganisationInvites.vue?vue&type=style&index=0&id=37ad74e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad74e9",
  null
  
)

export default component.exports